export const PROGRAMA_UNIAO_FAZ_A_VIDA_ID = 'a-uniao-faz-a-vida';
